import _ from 'lodash';

import {
  getQaBulletListReferal,
  getQuestionReferral,
  getQaBulletTags,
  saveQuestionQA,
} from '@/global/service';

import * as constants from './QA.constants';
import * as services from './QA.service';

const state = {
  isRequest: false,

  isReferalListLoading: false,
  referalList: [],

  qaBulletTags: {},
  qAskTags: [],

  selectedTagId: -1,
  selectedSubTagId: -1,

  res_doQuestionNew: {},
  res_doAnswerNew: {},
};

const mutations = {
  [constants.SET_IS_REQUEST_STATUS](state, status) {
    state.isRequest = status;
  },

  [constants.SET_IS_REFERAL_LIST_LOADING](state, isReferalListLoading) {
    state.isReferalListLoading = isReferalListLoading;
  },

  [constants.GET_REFERAL_LIST_SUCCESS](state, referalList) {
    if (undefined !== referalList && null !== referalList) {
      state.referalList = referalList;
    }
  },

  [constants.GET_QA_BULLET_TAGS_SUCCESS](state, qaBulletTags) {
    if (undefined !== qaBulletTags && null !== qaBulletTags) {
      state.qaBulletTags = qaBulletTags;
    }
  },

  [constants.GET_QA_QUESTION_ASK_TAGS_SUCCESS](state, qAskTags) {
    if (undefined !== qAskTags && null !== qAskTags) {
      state.qAskTags = qAskTags;
    }
  },

  [constants.SET_SELECTED_TAG_ID](state, selectedTagId) {
    state.selectedTagId = selectedTagId;
  },

  [constants.SET_SELECTED_SUBTAG_ID](state, selectedSubTagId) {
    state.selectedSubTagId = selectedSubTagId;
  },

  [constants.DO_QUESTION_NEW_SUCCESS](state, res_doQuestionNew) {
    if (undefined !== res_doQuestionNew && null !== res_doQuestionNew) {
      state.res_doQuestionNew = res_doQuestionNew;
    }
  },

  [constants.DO_ANSWER_NEW_SUCCESS](state, res_doAnswerNew) {
    if (undefined !== res_doAnswerNew && null !== res_doAnswerNew) {
      state.res_doAnswerNew = res_doAnswerNew;
    }
  },

  [constants.CLEAR_QA_STATE](state) {
    state.referalList = [];

    state.qaBulletTags = {};

    state.selectedTagId = -1;
    state.selectedSubTagId = -1;

    state.qAskTags = [];

    state.res_doQuestionNew = {};
    state.res_doAnswerNew = {};
  },
};

const actions = {
  async getQaBulletListReferal({ commit }, payload) {
    commit(constants.SET_IS_REFERAL_LIST_LOADING, true);
    const res = await getQaBulletListReferal(payload);
    commit(constants.GET_REFERAL_LIST_SUCCESS, res.data.data);
    commit(constants.SET_IS_REFERAL_LIST_LOADING, false);
  },

  async getQuestionReferral({ commit }, payload) {
    commit(constants.SET_IS_REFERAL_LIST_LOADING, true);
    const res = await getQuestionReferral(payload);
    commit(constants.GET_REFERAL_LIST_SUCCESS, res.data.data);
    commit(constants.SET_IS_REFERAL_LIST_LOADING, false);
  },

  async getQaBulletTags({ commit }, payload) {
    const res = await getQaBulletTags(payload);
    commit(constants.GET_QA_BULLET_TAGS_SUCCESS, res.data.data);
  },

  async getQaQuestionAskTags({ commit }, payload) {
    commit(constants.SET_IS_REQUEST_STATUS, true);
    const res = await services.getQaQuestionAskTags(payload);
    commit(constants.GET_QA_QUESTION_ASK_TAGS_SUCCESS, res.data.data);
    commit(constants.SET_IS_REQUEST_STATUS, false);
  },

  async doQuestionNew({ commit }, payload) {
    const res = await services.doQuestionNew(payload);
    commit(constants.DO_QUESTION_NEW_SUCCESS, res.data);
  },

  async doQuestionBulletNew({ commit }, payload) {
    const res = await services.doQuestionBulletNew(payload);
    commit(constants.DO_QUESTION_NEW_SUCCESS, res.data);
  },

  async saveQuestionQA({ commit }, payload) {
    const res = await saveQuestionQA(payload);
    commit(constants.DO_QUESTION_NEW_SUCCESS, res.data);
  },

  async doAnswerNew({ commit }, payload) {
    const res = await services.doAnswerNew(payload);
    commit(constants.DO_ANSWER_NEW_SUCCESS, res.data);
  },
};

const getters = {
  referalList: (state) => {
    return _.map(state.referalList, (v) => {
      // const content = v.qaContent.replace(/<[^>]+>/gi, '');
      return {
        ...v,
        formatTxt: v.formatQATitle ? v.formatQATitle : v.qaTitle,
      };
    });
  },

  isSelectedTag: (state) => {
    return -1 !== state.selectedTagId;
  },

  selectedTag: (state, getters) => {
    if (getters.isSelectedTag) {
      return _.find(state.qAskTags, (tag) => tag.tagId === state.selectedTagId);
    } else {
      return {
        subTags: [],
      };
    }
  },

  isNeedSubTag: (state, getters) => {
    return getters.isSelectedTag && 'Others' !== getters.selectedTag.tagCategory;
  },

  isSelectedSubTag: (state, getters) => {
    return getters.isSelectedTag && -1 !== state.selectedSubTagId;
  },
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
};
